import useRef from 'App/hooks/useRef'
import useState from 'App/hooks/useState'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import {Device} from '@twilio/voice-sdk'
import moment from 'moment'

export function useMyCallingCapabilityToken() {
  const {me} = useQuery({
    query: gql`
      query getCallingCapabilityToken {
        me {
          _id
          fullName
          callingCapabilityToken
        }
      }
    `,
    pollInterval: 1000 * 60 * 15 // We have to refetch the token every 10 minutes
  })

  return me
}

export default function useTwilioDevice(capabilityProfile) {
  const {callingCapabilityToken, _id, fullName} = capabilityProfile || {}
  const stopCallRef = useRef(() => {})

  const [currentCallPhoneNumber, setCurrentCallPhoneNumber] = useState(null)

  async function makeCall(phoneNumber, onStopCall) {
    setCurrentCallPhoneNumber(phoneNumber)

    const device = new Device(callingCapabilityToken, {appName: 'SupportDelivery'})
    const startDate = moment() //first time

    stopCallRef.current = async () => {
      device.destroy()
      setCurrentCallPhoneNumber(null)
      if (onStopCall) {
        await onStopCall(startDate, moment())
      }
    }

    const call = await device.connect({
      params: {
        To: phoneNumber,
        phoneNumber,
        userId: _id,
        fullName
      }
    })
    call.on('cancel', async () => {
      console.log('call canceled')
    })

    call.on('error', error => {
      console.log('Se produjo un error: ', error)
    })

    call.on('disconnect', async () => {
      setCurrentCallPhoneNumber(null)
      if (onStopCall) {
        await onStopCall(startDate, moment())
      }
    })
  }

  return {
    currentCallPhoneNumber,
    makeCall,
    stopCall: stopCallRef.current
  }
}
